import action from 'utils/createAction';
import ROUTER from 'types/router';

export default {
  goTo: (path, parameters) => action(ROUTER.GO_TO, { path, parameters }),
  goBack: () => action(ROUTER.GO_BACK),
  tryToRedirect: () => action(ROUTER.TRY_TO_REDIRECT),
  resolveMovieEnd: () => action(ROUTER.RESOLVE_MOVIE_END),
  goToErrorPage: (errorType = 'universal', location = {}) =>
    action(ROUTER.GO_TO_ERROR, { ...location, pathname: `/error/${errorType}` }),
};
